<script setup lang="ts">
// globals
defineProps({
  buttonText: {
    type: String,
    default: '',
  },
  color: {
    type: String,
    default: '',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  icon: {
    type: String,
    default: '',
  },
  iconSize: {
    type: String,
    default: undefined,
  },
  size: {
    type: String,
    default: 'small',
  },
  toolbar: {
    type: Boolean,
    default: true,
  },
  tooltip: {
    type: String,
    default: 'bottom',
  } as any,
  tooltipText: {
    type: String,
    default: '',
  },
  variant: {
    type: String,
    default: 'text',
  } as any,
})
</script>

<template>
  <v-btn
    :class="toolbar ? 'toolbar-button rounded-0' : ''"
    :color="disabled ? 'grey' : color"
    :disabled="disabled"
    :icon="!buttonText && !toolbar"
    :size="size"
    :variant="variant"
  >
    <v-icon
      v-if="icon"
      :icon="icon"
      :size="iconSize"
    />
    <slot />
    {{ buttonText }}
    <v-tooltip
      v-if="tooltipText"
      activator="parent"
      :disabled="disabled"
      :location="tooltip"
    >
      {{ tooltipText }}
    </v-tooltip>
  </v-btn>
</template>

<style lang="sass" scoped>
  .toolbar-button
    height: 48px
    min-width: 48px
</style>
